export default __webpack_public_path__ + "static/media/logo-white.d93de26d.svg";